module.exports = __webpack_public_path__ + "img/group-item.d57eb097.svg";